import Vue from 'vue';
import Router from 'vue-router';
import Hello from '@/components/Hello';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Dispense from '@/pages/Dispense';
import Transactions from '@/pages/Transactions';
import Users from '@/pages/Users';
import DUsers from '@/pages/dothraki/Users';
import Batches from '@/pages/dothraki/Batches';
import Payments from '@/pages/dothraki/Payments';
import Batch from '@/pages/dothraki/Batch';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/hello',
      name: 'Hello',
      component: Hello,
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/status',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/dispense',
      name: 'Dispense',
      component: Dispense,
      meta: { requiresAuth: true }
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: Transactions,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: { requiresAuth: true }
    },
    {
      path: '/d/users',
      name: 'D Users',
      component: DUsers,
      meta: { requiresAuth: true }
    },
    {
      path: '/d/batches',
      name: 'Batches',
      component: Batches,
      meta: { requiresAuth: true }
    },
    {
      path: '/d/payments',
      name: 'Payments',
      component: Payments,
      meta: { requiresAuth: true }
    },
    {
      path: '/d/batches/:id',
      name: 'Batch',
      component: Batch,
      meta: { requiresAuth: true }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js